import { render, staticRenderFns } from "./Yesterday.vue?vue&type=template&id=5c4b5bf0&scoped=true"
import script from "./Yesterday.vue?vue&type=script&lang=js"
export * from "./Yesterday.vue?vue&type=script&lang=js"
import style0 from "./Yesterday.vue?vue&type=style&index=0&id=5c4b5bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b5bf0",
  null
  
)

export default component.exports